// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".AddLanguage__container___2aFC-{padding:10px}.AddLanguage__addButton___1-ZWb{margin-top:10px !important}\n", ""]);
// Exports
exports.locals = {
	"container": "AddLanguage__container___2aFC-",
	"addButton": "AddLanguage__addButton___1-ZWb"
};
module.exports = exports;
